/**
 * WebGPU browser-compat shims.
 *
 * three r185 (latest at time of writing) fills GPUTextureViewDescriptor with
 * `swizzle: 'rgba'` on every sampled-texture view it creates. The component
 * swizzle proposal that shipped in Chromium 141+ types `swizzle` as a
 * dictionary (GPUTextureComponentSwizzle), not a string, and Chromium
 * *validates* the member even when the `'texture-component-swizzle'` feature
 * is absent — so every createView() throws, bind groups never build, and
 * layers (or whole postprocessing chains) silently render nothing. Android
 * Chrome hits the identical bug, so shipped effects need this as much as the
 * editor does. iOS Safari / non-WebGPU browsers take the WebGL2 fallback and
 * never reach this code.
 *
 * The value three passes is always the identity swizzle, so dropping a
 * string-typed `swizzle` before calling the native method is lossless.
 * Remove once three ships a release that only sets the member when the
 * feature is enabled.
 */
let patched = false;
export function applyWebGPUTextureViewCompat() {
    if (patched)
        return;
    const proto = globalThis.GPUTexture
        ?.prototype;
    if (!proto)
        return; // WebGL2-only browser or headless/node — nothing to patch
    patched = true;
    const original = proto.createView;
    proto.createView = function (descriptor) {
        if (descriptor && typeof descriptor.swizzle === 'string') {
            const clean = { ...descriptor };
            delete clean.swizzle;
            return original.call(this, clean);
        }
        return original.call(this, descriptor);
    };
}
